import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const planPageWithoutScenarioIdRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps',
	path: '/jira/plans/:planId(\\d+)',
};
